import axios from 'axios';

// Push (FCM). Kompyuter/brauzerda — Firebase web SDK + service worker; telefon ilovasida
// (Flutter WebView) — native FCM: Flutter tokenni ERPlineNative JS kanali orqali beradi.
// Firebase SDK (~150 KB) ATAYLAB dinamik import — asosiy bundle'ga tushmasin.
const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const FIREBASE_CONFIG = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const DISABLED_KEY = 'erpline_push_disabled';   // foydalanuvchi o'zi o'chirgan — avto qayta obuna yo'q
const TOKEN_KEY    = 'erpline_push_token';      // shu qurilma tokeni (logout'da o'chirish uchun)

const lsGet = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const lsSet = (k, v) => { try { localStorage.setItem(k, v); } catch { /* ignore */ } };
const lsDel = (k) => { try { localStorage.removeItem(k); } catch { /* ignore */ } };

export const isPushDisabledByUser = () => lsGet(DISABLED_KEY) === '1';

// Native ilova (Flutter WebView) ichidami?
export const isNativeApp = () => typeof window !== 'undefined' && typeof window.ERPlineNative !== 'undefined';

const firebaseConfigured = () => !!(FIREBASE_CONFIG.apiKey && FIREBASE_CONFIG.projectId && FIREBASE_CONFIG.appId && VAPID_KEY);

export function pushSupported() {
  if (isNativeApp()) return true;
  return typeof window !== 'undefined' && firebaseConfigured() &&
    'serviceWorker' in navigator && 'Notification' in window && 'PushManager' in window;
}

export const pushPermission = () => (typeof Notification !== 'undefined' ? Notification.permission : 'denied');

async function saveToken(token, platform, cap) {
  await axios.post(`${API}/push/subscribe`, { token, platform, cap });
  lsSet(TOKEN_KEY, token);
  lsDel(DISABLED_KEY);
}

async function loadMessaging() {
  const [{ initializeApp, getApps }, m] = await Promise.all([import('firebase/app'), import('firebase/messaging')]);
  const app = getApps()[0] || initializeApp(FIREBASE_CONFIG);
  return { ...m, messaging: m.getMessaging(app) };
}

// Native: Flutter'dan FCM tokenni so'raymiz; u window.__onNativePushToken orqali qaytaradi.
function initNativePush() {
  // cap — ilova imkoniyati (masalan 'urgent-v1': baland ovozli kanal bor). Eski ilovalar uni yubormaydi.
  window.__onNativePushToken = async (token, cap) => {
    if (!token) return;
    try { await saveToken(token, 'native', cap); } catch { /* keyingi kirishda qayta uriniladi */ }
  };
  try { window.ERPlineNative.postMessage('getToken'); } catch { /* ignore */ }
}

// interactive=true — foydalanuvchi tugma bosgan (brauzer ruxsat so'raydi).
export async function subscribeToPush({ interactive = false } = {}) {
  if (isNativeApp()) { initNativePush(); return { ok: true, native: true }; }
  if (!pushSupported()) return { ok: false, reason: 'unsupported' };
  if (!interactive && isPushDisabledByUser()) return { ok: false, reason: 'user_disabled' };

  let permission = Notification.permission;
  if (permission !== 'granted') {
    if (!interactive) return { ok: false, reason: permission === 'denied' ? 'denied' : 'not_granted' };
    try { permission = await Notification.requestPermission(); } catch { return { ok: false, reason: 'request_failed' }; }
    if (permission !== 'granted') return { ok: false, reason: permission === 'denied' ? 'denied' : 'not_granted' };
  }
  try {
    const { getToken, messaging } = await loadMessaging();
    const reg = await navigator.serviceWorker.ready;
    const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: reg });
    if (!token) return { ok: false, reason: 'no_token' };
    await saveToken(token, 'web');
    return { ok: true };
  } catch (err) {
    return { ok: false, reason: 'subscribe_failed', error: err.message };
  }
}

// Ilova ochiq paytda kelgan push — ichki bildirishnoma ro'yxatini darrov yangilash uchun.
export async function initForegroundMessages(onMessage) {
  if (isNativeApp() || !pushSupported() || pushPermission() !== 'granted') return () => {};
  try {
    const { onMessage: listen, messaging } = await loadMessaging();
    return listen(messaging, (payload) => onMessage?.(payload));
  } catch { return () => {}; }
}

// Logout'da: shu qurilma tokenini serverdan olib tashlaymiz (boshqa akkaunt/qurilmalar tegilmaydi).
export async function detachPush() {
  const token = lsGet(TOKEN_KEY);
  lsDel(TOKEN_KEY);
  if (!token) return;
  try { await axios.post(`${API}/push/unsubscribe`, { token }); } catch { /* ignore */ }
}
